export const ForgotPasswordInitialValues = [
    { email: "" },
    { code: "" },
    { newPassword: "", confirmPassword: "" },
];



